import React, { Component }  from 'react';
import AdminTable            from '../../components/AdminTable.jsx';
import PageHeaderBar         from '../../components/PageHeaderBar.jsx';
import Modal                 from '../../components/Modal.jsx';
import FAQForm               from './FAQForm.jsx';
import { faqRecord }         from './faqRecord.js';
import { statusTypesLookup } from '../../data/refData.js';
import { fetchEndpoint }     from '../../functions.js';

class FAQs extends Component {

  constructor() {
    super();
    this.tableRef = React.createRef();
    this.formRef  = React.createRef();
    this.state = {
      mode          : 'list',   // list | create | edit
      currentItem   : {},       // The item being created or manipulated
      deleteModal   : false,    // Toggles visibility of modal
    };
  }

  onCloseModal      = ()     => this.setState({ deleteModal: false });
  gotoListMode      = ()     => this.setState({ mode: 'list' });
  createItem        = ()     => this.setState({ currentItem : faqRecord(null, 'create'), mode : 'create' });
  editItem          = (item) => this.setState({ currentItem : faqRecord(item, 'edit'),   mode : 'edit'   });
  copyItem          = (item) => this.setState({ currentItem : faqRecord(item, 'create'), mode : 'create' });
  promptForDeletion = (item) => this.setState({ currentItem : item, deleteModal: true });

  onSaveItem = async () => {
    const { notifySuccess, notifyError } = this.props;
    const { mode } = this.state;
    // get the form item data via its reference
    const { item } = this.formRef.current.state;

    let saveURL = '/api/faqs';
    if (mode === 'edit') saveURL += '/'+ item._id;

    await fetchEndpoint({
      url       : saveURL,
      body      : item,
      onSuccess : () => {
        notifySuccess(`FAQ saved`);
        this.setState({ mode : 'list' }, () => {
          this.tableRef.fireFetchData();
        });
      },
      onError   : (error) => {
        console.log('error during save', error);
        notifyError('sorry there was an error and you cannot continue');
      },
    });
  }

  onDeleteCurrentItem = async () => {
    const { currentItem } = this.state;
    const { notifySuccess, notifyError } = this.props;
    await fetchEndpoint({
      url       : '/api/faqs/' + currentItem._id,
      method    : 'DELETE',
      onSuccess : () => {
        notifySuccess(`FAQ deleted`);
        this.setState({ mode : 'list' }, () => {
          this.onCloseModal();
          this.tableRef.fireFetchData();
        });
      },
      onError   : (error) => {
        console.log('error during delete', error);
        notifyError('sorry there was an error and you cannot continue');
      },
    });
  }

  render() {

    const { notifyError } = this.props;
    const { mode, currentItem, deleteModal } = this.state;
    const columns = [
      { 
        Header    : 'Question',
        id        : 'faq_question',
        accessor  : 'faq_question',
        sortable  : true,
        resizable : true,
      },
      { 
        Header    : 'For Share',
        id        : 'sha_title',
        accessor  : '_xrefs.share.sha_title',
        sortable  : true,
        maxWidth  : 300,
        resizable : true,
      },
      { 
        Header    : 'Status',
        id        : 'faq_status',
        accessor  : 'faq_status.sta',
        sortable  : true,
        maxWidth  : 110,
        resizable : false,
        Cell      : field => (<div style={{ textAlign: 'center' }}>{statusTypesLookup(field.value)}</div>),
      },
      { 
        Header    : 'Actions',
        sortable  : false,
        maxWidth  : 150,
        resizable : false,
        Cell      : field => (
          <div style={{ textAlign: 'center' }}>
            <span className="tbl-lnk" onClick={()=>this.editItem(field.original)}>Edit</span>
            &nbsp;|&nbsp;
            <span className="tbl-lnk" onClick={()=>this.copyItem(field.original)}>Copy</span>
            &nbsp;|&nbsp;
            <span className="tbl-lnk" onClick={()=>this.promptForDeletion(field.original)}>Delete</span>
          </div>
        ),
      },
    ];

    return (
      <div>
        <PageHeaderBar
          mode={mode}
          typeSingle="FAQ"
          typePlural="FAQs"
          onCreate={this.createItem}
          onCancel={this.gotoListMode}
          onSave={this.onSaveItem}
        />
        <div style={{ display: mode === 'list' ? 'block' : 'none' }}>
          <AdminTable
            setTableRef={(tableRef) => this.tableRef = tableRef}
            fetchURL={'/api/faqs'}
            notifyError={notifyError}
            columns={columns}
            filters={[
              { title: 'Status', name: 'faq_status.sta', type: 'status' },
            ]}
            defaultSorted={{ id: 'name', desc: false }}
          />
        </div>

        {['create', 'edit', 'copy'].includes(mode) && (
          <FAQForm ref={this.formRef} item={currentItem} />
        )}

        <Modal
          title={`Delete FAQ: ${currentItem ? currentItem.faq_question : ''}`}
          open={deleteModal}
          action="Delete"
          onAction={this.onDeleteCurrentItem}
          onClose={this.onCloseModal}
        />
        
      </div>
    );
  }
}

export default FAQs;
